import { useQuery } from "@tanstack/react-query";
import apiClient from "@/services/api/client";
import { API_ENDPOINTS } from "@/services/api/endpoints";
import { QUERY_KEYS } from "@/services/api/queryKeys";
import type { SystemAnalytics } from "@/types";

export const useAnalytics = () => {
  const analyticsQuery = useQuery({
    queryKey: QUERY_KEYS.ANALYTICS.SYSTEM,
    queryFn: async () => {
      const response = await apiClient.get<SystemAnalytics>(
        API_ENDPOINTS.SYSTEM.ANALYTICS
      );
      return response.data;
    },
  });

  return {
    analytics: analyticsQuery.data,
    isLoading: analyticsQuery.isLoading,
    error: analyticsQuery.error,
    refetch: analyticsQuery.refetch,
  };
};
